import * as types from '../constants';

const initialState = {
  hotelListTotal: 0,
  hotelListItems: [],
};

const HotelListReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_HOTEL_LIST:
      return {
        ...state,
        hotelListTotal: action.payload.total,
        hotelListItems: action.payload.items,
      };
    default:
      return state;
  }
};

export default HotelListReducer;